var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      class: _vm.gameItemClass,
    },
    [
      _c(
        "div",
        {
          staticClass: "px-0",
        },
        [
          _c(
            "pre",
            {
              staticClass: "text-center pb-0 font-primary",
              class: _vm.gameItemHeaderClass,
            },
            [_vm._v(_vm._s(_vm.titleTemp))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.gameItemBodyClass,
        },
        [
          _c(
            "h4",
            {
              class: _vm.gameItemTimeEndClass,
            },
            [_vm._v("\n      " + _vm._s(_vm.closeAt) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "card-text text-center text-lg my-0 py-0",
            },
            [
              _c("countdown", {
                attrs: {
                  "type-countdown": "lotto",
                  "seconds-left": _vm.secondsLeft,
                },
                on: {
                  "game-timeout": _vm.gameTimeout,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-footer bg-white py-2 text-center",
        },
        [
          _c(
            "a",
            {
              class: _vm.gameItemButtonClass,
              attrs: {
                href: _vm.gameLink,
              },
            },
            [_vm._v(_vm._s(_vm.linkText))]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }